module.exports = __webpack_public_path__ + "data-table.b0aebd744ce7adb780a9.svg";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/@swimlane/ngx-datatable/release/assets/fonts/data-table.svg
// module id = ../../../../@swimlane/ngx-datatable/release/assets/fonts/data-table.svg
// module chunks = 40